"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueDisplay = void 0;
/* eslint-disable react/no-multi-comp */
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const client_1 = require("@apollo/client");
const react_router_dom_1 = require("react-router-dom");
const graphql_1 = require("./graphql");
const polaris_1 = require("@shopify/polaris");
const ProblemOrdersIcon_1 = require("components/ProblemOrdersIcon");
const ShipmentCards_1 = __importDefault(require("./ShipmentCards"));
const styles_1 = require("./styles");
const AccountContext_1 = require("contexts/AccountContext");
const ErrorBanner_1 = require("./ErrorBanner");
const polaris_icons_1 = require("@shopify/polaris-icons");
const utils_1 = require("./utils");
const pluralize = (count, noun, suffix = 's') => {
    let definedCount = count;
    if (!count) {
        definedCount = 0;
    }
    return `${definedCount} ${noun}${definedCount !== 1 ? suffix : ''}`;
};
const rulesMappings = {
    FulfillmentStalled: 'Stalled In Fulfillment',
    ShipmentStalled: 'Stalled In Transit',
    ShipmentReturnedToSender: 'Returned To Sender',
    ShipmentDeliveryAttempted: 'Delivery Attempted'
};
const IssueDisplay = ({ issue }) => {
    const insertedAt = (0, moment_1.default)(issue.insertedAt);
    const formattedDate = insertedAt.format('MMM D');
    const formattedTime = insertedAt.format('h:mma');
    const formattedDateTime = `${formattedDate} at ${formattedTime}`;
    return (react_1.default.createElement(polaris_1.LegacyStack, { spacing: 'tight' },
        react_1.default.createElement(ProblemOrdersIcon_1.ProblemOrdersIcon, null),
        react_1.default.createElement(polaris_1.Text, { as: 'span', tone: 'critical' },
            rulesMappings[issue.rule.name],
            ": ",
            formattedDateTime)));
};
exports.IssueDisplay = IssueDisplay;
const getSecondaryActions = (orderUrl, orderManagementUrl) => {
    let actions = [];
    if (orderManagementUrl) {
        actions = actions.concat([
            {
                content: 'Shopify Order Page',
                external: true,
                icon: polaris_icons_1.ExternalIcon,
                url: orderManagementUrl
            }
        ]);
    }
    if (orderUrl) {
        actions = actions.concat([
            {
                content: 'View Tracking Page',
                external: true,
                icon: polaris_icons_1.ExternalIcon,
                url: orderUrl
            }
        ]);
    }
    if (actions.length) {
        return actions;
    }
    return undefined;
};
// eslint-disable-next-line complexity
const OrderDetails = () => {
    var _a, _b, _c, _d, _e, _f;
    const { account } = (0, AccountContext_1.useAccount)();
    const [getOrder, { data, loading, error }] = (0, client_1.useLazyQuery)(graphql_1.GET_ORDER);
    const { orderId } = (0, react_router_dom_1.useParams)();
    const { id: accountId } = account || {};
    const navigate = (0, react_router_dom_1.useNavigate)();
    // watch for account changes
    (0, react_1.useEffect)(() => {
        if (accountId && orderId) {
            getOrder({ variables: { accountId, id: orderId } });
        }
    }, [accountId]);
    if (loading) {
        return (react_1.default.createElement(styles_1.StyledSpinnerContainer, null,
            react_1.default.createElement(polaris_1.Spinner, { accessibilityLabel: 'Loading', size: 'large' })));
    }
    if ((error && error.message.includes('Response not successful')) ||
        !(data === null || data === void 0 ? void 0 : data.order)) {
        return (react_1.default.createElement(styles_1.StyledPageContainer, null,
            react_1.default.createElement(polaris_1.Page, null,
                react_1.default.createElement(ErrorBanner_1.ErrorBanner, { message: 'This order can\u2019t be found or has been deleted.', title: 'Order Not Found' }))));
    }
    if (error) {
        return (react_1.default.createElement(styles_1.StyledPageContainer, null,
            react_1.default.createElement(polaris_1.Page, null,
                react_1.default.createElement(ErrorBanner_1.ErrorBanner, { message: 'The server could not be reached, please try again later.', title: 'Server Error' }))));
    }
    const fulfillmentStalledIssues = data.order.issues.edges.filter((issue) => issue.node.rule.name === 'FulfillmentStalled');
    const secondaryActions = getSecondaryActions(data.order.url, data.order.orderManagementUrl);
    const shippingAddress = data.order.shippingAddress;
    return (react_1.default.createElement(styles_1.StyledPageContainer, null,
        react_1.default.createElement(polaris_1.Page, { backAction: { content: 'Orders', onAction: () => navigate(-1) }, fullWidth: true, secondaryActions: secondaryActions, title: data.order.name || data.order.number },
            react_1.default.createElement(polaris_1.Layout, null,
                react_1.default.createElement(polaris_1.Layout.Section, null,
                    react_1.default.createElement(polaris_1.Box, { paddingBlockEnd: '400' },
                        react_1.default.createElement(polaris_1.LegacyCard, { title: 'Order Details' },
                            react_1.default.createElement(polaris_1.LegacyCard.Section, null,
                                react_1.default.createElement(polaris_1.Text, { as: 'p', tone: 'subdued' },
                                    "Placed",
                                    ' ',
                                    (0, moment_1.default)(data.order.placedAt || data.order.insertedAt).format('LL [at] LT')),
                                fulfillmentStalledIssues.length > 0 && (react_1.default.createElement(polaris_1.Box, { paddingBlockStart: '400' },
                                    react_1.default.createElement(polaris_1.BlockStack, { gap: '200' }, fulfillmentStalledIssues.map((issue) => (react_1.default.createElement(exports.IssueDisplay, { issue: issue.node, key: issue.node.id }))))))))),
                    react_1.default.createElement(ShipmentCards_1.default, { order: data.order })),
                react_1.default.createElement(polaris_1.Layout.Section, { variant: 'oneThird' },
                    react_1.default.createElement(polaris_1.LegacyCard, { title: 'Customer' },
                        react_1.default.createElement(polaris_1.LegacyCard.Section, null, data.order.customer ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("p", { className: 'customer-name' }, (0, utils_1.formatCustomerName)(data.order.customer)),
                            react_1.default.createElement("p", { className: 'order-count' }, pluralize((_a = data.order.customer) === null || _a === void 0 ? void 0 : _a.orderCount, 'order')))) : (react_1.default.createElement(polaris_1.Text, { as: 'p', tone: 'subdued' }, "No Customer Details"))),
                        react_1.default.createElement(polaris_1.LegacyCard.Section, { title: 'CONTACT INFORMATION' },
                            react_1.default.createElement(polaris_1.LegacyStack, { spacing: 'extraTight', vertical: true },
                                react_1.default.createElement(polaris_1.Link, { url: `mailto:${(_c = (_b = data.order) === null || _b === void 0 ? void 0 : _b.customer) === null || _c === void 0 ? void 0 : _c.email}` }, (_d = data.order.customer) === null || _d === void 0 ? void 0 : _d.email),
                                ((_e = data.order.customer) === null || _e === void 0 ? void 0 : _e.phoneNumber) ? (react_1.default.createElement("p", { className: 'phone-number' }, (_f = data.order.customer) === null || _f === void 0 ? void 0 : _f.phoneNumber)) : (react_1.default.createElement(polaris_1.Text, { as: 'p', tone: 'subdued' }, "No Phone Number")))),
                        shippingAddress && (react_1.default.createElement(polaris_1.LegacyCard.Section, { title: 'SHIPPING ADDRESS' },
                            react_1.default.createElement(polaris_1.BlockStack, null,
                                react_1.default.createElement(polaris_1.Text, { as: 'span' }, (0, utils_1.formatCustomerName)(shippingAddress)),
                                react_1.default.createElement(polaris_1.Text, { as: 'span' }, shippingAddress.address1),
                                react_1.default.createElement(polaris_1.Text, { as: 'span' }, shippingAddress.address2),
                                react_1.default.createElement(polaris_1.Text, { as: 'span' },
                                    shippingAddress.city,
                                    shippingAddress.city && ', ',
                                    shippingAddress.provinceCode,
                                    " ",
                                    shippingAddress.zip),
                                react_1.default.createElement(polaris_1.Text, { as: 'span' }, shippingAddress.country))))))))));
};
exports.default = OrderDetails;
